'use client';

import { useEffect } from 'react';

/**
 * Registers the PWA service worker when running in the browser.
 * Registration failures must never block login or app startup.
 */
export function PwaRegister() {
  useEffect(() => {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;

    // In development, disable SW to prevent stale Next.js chunks/HMR failures.
    if (process.env.NODE_ENV !== 'production') {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => {
          reg.unregister();
        });
      }).catch((err) => {
        console.warn('SW unregister failed', err);
      });

      if ('caches' in window) {
        caches.keys().then((keys) => {
          keys
            .filter((k) => k.startsWith('EnthiosHub-v') || k.startsWith('EnthiosHub-v'))
            .forEach((k) => {
              caches.delete(k);
            });
        }).catch(() => {});
      }
      return;
    }

    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => reg.update())
      .catch((err) => {
        console.warn('SW registration failed', err);
      });
  }, []);

  return null;
}
